import type { TicketCustomerLinkDto, TicketDetailDto } from "@megaron/support-contracts";
import type { Uuid } from "@megaron/uuid";

export function getReporterCustomerUuidFromLinks(customers: TicketCustomerLinkDto[]): Uuid | undefined {
  return customers.find((customer) => customer.isReporter)?.customerUuid;
}

export function getAssignedCustomersFromLinks(customers: TicketCustomerLinkDto[]): TicketCustomerLinkDto[] {
  return customers.filter((customer) => !customer.isReporter);
}

export function getReporterCustomerUuidFromTicket(ticket: TicketDetailDto): Uuid | undefined {
  return getReporterCustomerUuidFromLinks(ticket.ticketCustomers);
}

export function getAssignedCustomersFromTicket(ticket: TicketDetailDto): TicketCustomerLinkDto[] {
  return getAssignedCustomersFromLinks(ticket.ticketCustomers);
}
